// extracted by mini-css-extract-plugin
export default {"container":"styles_container__a+2fz","spinner":"styles_spinner__qCmIk"};